import React, {useRef, useState} from 'react';
import PropTypes from 'prop-types';
import css from './IconButtonMenu.module.scss';
import {useClickOutside} from '../../hooks/useClickOutside';

const IconButtonMenu = ({icon, title, label, badge, children}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  useClickOutside(wrapperRef, () => setIsOpen(false));

  return (
    <div ref={wrapperRef} className={css.wrapper}>
      <button
        className={css.trigger}
        onClick={() => setIsOpen(!isOpen)}
        aria-label={label}
        title={label}
      >
        {icon}
        {badge && <span className={css.badge}>{badge}</span>}
      </button>
      {isOpen &&
        <div className={css.menu} onClick={() => setIsOpen(false)}>
          {title && <div className={css.menuHeader}>{title}</div>}
          {children}
        </div>
      }
    </div>
  );
};

const MenuItem = ({onClick, children, subtitle, endContent}) => (
  <button className={css.menuItem} onClick={onClick}>
    <div className={css.menuItemContent}>
      <span>{children}</span>
      {subtitle && <span className={css.menuItemSub}>{subtitle}</span>}
    </div>
    {endContent && <div className={css.menuItemEnd}>{endContent}</div>}
  </button>
);

MenuItem.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  endContent: PropTypes.node,
};

IconButtonMenu.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string,
  label: PropTypes.string,
  badge: PropTypes.string,
  children: PropTypes.node,
};

IconButtonMenu.Item = MenuItem;

export default IconButtonMenu;
